import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import './App.css';
import MainContent from '../../components/MainContent';
import RegistrationLinkInfo from '../../components/RegistrationLinkInfo';
import TopHeader from '../../components/TopHeader';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { endpoints } from '../../config';

const pa_theme = createMuiTheme({
  palette: {
    secondary: { main: '#006BA6' }
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#006BA6',
        '&:hover': {
          backgroundColor: '#006BA6'
        }
      }
    }
  }
});

function App() {
  const querySearch = queryString.parse(window.location.search);
  const companyKey = querySearch.companyKey ? encodeURIComponent(querySearch.companyKey.toString()) : '';
  const okey = querySearch.okey ? querySearch.okey.toString() : '';
  const rkey = querySearch.rkey ? querySearch.rkey.toString() : '';
  const portalId = querySearch.portalId ? querySearch.portalId.toString() : '';
  const contractId = querySearch.contractId ? querySearch.contractId.toString() : '';

  const [clientLogo, setClientLogo] = useState('');
  const [companyName, setCompanyName] = useState('logo');
  const [isRegistrationLinkExpired, setRegistrationLinkExpired] = useState(false);

  useEffect(() => {
    // Checks if the Event Registration Link is enabled
    if(okey){
      axios.get(`${endpoints.SupplierRegistrationLink}/expired?okey=${okey}`).then(resp => {
        setRegistrationLinkExpired(resp.data.value);
      });
    }

    axios.get(`${endpoints.CompanyInfo}?companyKey=${companyKey}`).then(companyData => {
      const clientLogo: string = `/ftp/companylogos/${companyData.data.response.clientLogo}`;
      setClientLogo(clientLogo);
      setCompanyName(companyData.data.response.companyName);
    });
  }, [companyKey, okey]);

  return (
    <div className="App">
      <MuiThemeProvider theme={pa_theme}>
        <TopHeader clientLogo={clientLogo} companyName={companyName} />
        {isRegistrationLinkExpired ? (
          <RegistrationLinkInfo 
            companyKey={companyKey}
          />
        ) : (
          <MainContent
            companyKey={companyKey}
            companyName={companyName}
            portalId={portalId}
            contractId={contractId}
            okey={okey}
            rkey={rkey}
          />
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default App;
